import { message } from "antd";
import React, { useState } from "react";
import DataListTable from "../list/DataListTable";
const UploadForm = () => {
  return (
    <>
      <DataListTable />
    </>
  );
};
export default UploadForm;
